import {Injectable} from '@angular/core'

import {
  DFFormConfig,
  DFTabConfig,
  DFFieldConfig,
  DFCondition,
  DFFieldConfigChoice,
} from '@shared/dynamic-form'

export interface ConversionOptions {
  disabled?: boolean
}

@Injectable()
export class ConfigurationTreeConversionService {
  assetOptions = []

  public getDynamicFormConfig(
    tree: any,
    opts: ConversionOptions = {},
    assetOptions: DFFieldConfigChoice[] = [],
    isApollo = false,
  ) {
    const formConfig: DFFormConfig = {tabs: []}
    this.assetOptions = assetOptions

    if (!!tree.root) {
      tree.root.children.forEach((element) => {
        switch (element.type) {
          case 'Group':
            // handle terminal interface as a group
            if (element.key === 'terminal.interface') {
              formConfig.tabs.push(
                this.buildSiteSettingsTab(element.children[0], [], opts),
              )
            } else {
              formConfig.tabs.push(this.buildSiteSettingsTab(element, [], opts))
            }
            break
          case 'Choice':
            if (element.key === 'terminal.interface' && element.options) {
              // add this to the general tab
              const modeField = {
                label: 'Mode',
                name: element.key,
                key: element.key,
                disabled: opts.disabled || element.readOnly,
                level: 0,
                type: 'choice',
                choices: this.convertOptions(element.options),
                conditions: [],
              }
              formConfig.tabs[0].fields.splice(0, 0, modeField)

              const key = element.key
              let idx = 0
              for (const tabElem of element.children) {
                const value = element.options[idx++]
                const conditions = [
                  (settings) => {
                    return settings.get(key) === value
                  },
                ]
                if (tabElem != null) {
                  formConfig.tabs.push(
                    this.buildSiteSettingsTab(tabElem, conditions, opts),
                  )
                }
              }
            }
            break
        }
      })
    }
    if (isApollo) {
      // rework the following to check for "terminal.pulse-enabled" OR 'terminal.interface.autoscan.pulse-enabled'
      // to return the pulse tab. Remove if(autsscan) and only check on the above

      const isPulseEnabled = (settings) => {
        const pulseEnabledKey =
          settings.get('terminal.pulse-enabled') === 'true'
        const autoscanPulseEnabledKey =
          settings.get('terminal.interface.autoscan.pulse-enabled') === 'true'

        // Return true if EITHER setting is 'true'
        return pulseEnabledKey || autoscanPulseEnabledKey
      }

      let pulseTab = this.buildSiteSettingsTab(
        {
          key: 'pulse',
          type: 'Group',
          description: 'pulse settings',
          readOnly: false,
          children: [],
          name: 'Pulse',
          title: 'Pulse',
        },
        [isPulseEnabled],
        opts,
      )

      pulseTab.fields.push({
        label: 'Pulse',
        name: 'Pulse',
        key: 'pulse',
        disabled: false,
        type: 'pulse_selection',
        choices: this.assetOptions,
      })
      formConfig.tabs.push(pulseTab)

      // if apollo add custom platform manager selector as a basic setting
      formConfig.tabs.push({
        active: true,
        conditions: [],
        fields: [
          {
            label: 'Assets',
            name: 'Assets',
            key: 'platform-manager',
            disabled: false,
            type: 'free_asset_selection',
            choices: this.assetOptions,
          },
        ],
        name: 'uiscreens',
        title: 'UI - Screens',
      })
      // remove reboot settings for now
      // const generalObjectIndex = formConfig.tabs.findIndex(obj => obj.title === 'General');
      // if (generalObjectIndex !== -1) {
      //     // Remove the specified fields from the 'fields' array
      //     formConfig.tabs[generalObjectIndex].fields = formConfig.tabs[generalObjectIndex].fields.filter(field =>
      //         field.label !== 'Automatic reboot Hours' && field.label !== 'Automatic reboot Minutes'
      //     );
      // }
    }

    return formConfig
  }

  private buildSiteSettingsTab(
    tab: any,
    conditions: DFCondition[] = [],
    opts: ConversionOptions = {},
  ) {
    const name = tab.key.split('.').pop()
    const tabConfig: DFTabConfig = {
      name: name,
      title: tab.name,
      conditions: conditions,
      fields: [],
    }

    tab.children.forEach((element) => {
      tabConfig.fields = tabConfig.fields.concat(
        this.buildSiteSettingsField(element, [], 0, opts),
      )
    })

    return tabConfig
  }

  private buildSiteSettingsField(
    field: any,
    conditions: DFCondition[],
    level: number,
    opts: ConversionOptions = {},
  ) {
    let fieldConfigs: DFFieldConfig[] = []

    switch (field.type) {
      case 'Setting':
        switch (field.setting) {
          case 'string':
            // if ( field.key === 'terminal.ui.backlight_coeffecient' ) {
            //   // Convert the logo field to a choice field with the asset choices
            //   fieldConfigs.push({
            //     label: field.name,
            //     name: field.key,
            //     key: field.key,
            //     disabled: opts.disabled || field.readOnly,
            //     level: level,
            //     type: 'number',
            //     conditions: conditions.slice()
            //   });
            // }

            if (field.key === 'terminal.ui.customize.logo') {
              // Convert the logo field to a choice field with the asset choices
              fieldConfigs.push({
                label: field.name,
                name: field.key,
                key: field.key,
                disabled: opts.disabled || field.readOnly,
                level: level,
                type: 'choice',
                choices: this.assetOptions,
                conditions: conditions.slice(),
              })
            } else {
              fieldConfigs.push({
                label: field.name,
                name: field.key,
                key: field.key,
                disabled: opts.disabled || field.readOnly,
                level: level,
                type: 'string',
                conditions: conditions.slice(),
              })
            }
            break
          case 'truefalse':
            fieldConfigs.push({
              label: field.name,
              name: field.key,
              key: field.key,
              disabled: opts.disabled || field.readOnly,
              level: level,
              type: 'yesNo',
              conditions: conditions.slice(),
            })
            break
          case 'integer':
            fieldConfigs.push({
              label: field.name,
              name: field.key,
              key: field.key,
              disabled: opts.disabled || field.readOnly,
              level: level,
              type: 'number',
              conditions: conditions.slice(),
            })
            break
          case 'choice':
            fieldConfigs.push({
              label: field.name,
              name: field.key,
              key: field.key,
              disabled: opts.disabled || field.readOnly,
              level: level,
              type: 'choice',
              choices: this.convertOptions(field.options),
              conditions: conditions.slice(),
            })
            break
          case 'DynamicGroup':
            fieldConfigs.push({
              label: field.name,
              name: field.key,
              key: field.key,
              disabled: opts.disabled || field.readOnly,
              level: level,
              type: 'DynamicGroup',
              // content: field.children,
              conditions: conditions.slice(),
            })
            break
        }
        break
      case 'Choice':
        fieldConfigs.push({
          label: field.name,
          name: field.key,
          key: field.key,
          disabled: opts.disabled || field.readOnly,
          level: level,
          type: 'choice',
          choices: this.convertOptions(field.options),
          conditions: conditions.slice(),
        })
        if (field.options) {
          field.options.forEach((choice, index) => {
            if (field.children[index]) {
              const key = field.key
              conditions.push((settings) => {
                return settings.get(key) === choice
              })
              fieldConfigs = fieldConfigs.concat(
                this.buildSiteSettingsField(
                  field.children[index],
                  conditions,
                  level + 1,
                  opts,
                ),
              )
              conditions.pop()
            }
          })
        }
        break
      case 'Optional':
        fieldConfigs.push({
          label: field.name,
          name: field.key,
          key: field.key,
          disabled: opts.disabled || field.readOnly,
          level: level,
          type: 'yesNo',
          conditions: conditions.slice(),
        })
        /* True (Yes) Node */
        if (field.children[0]) {
          const key = field.key
          conditions.push((settings) => {
            return settings.get(key) === 'true'
          })
          fieldConfigs = fieldConfigs.concat(
            this.buildSiteSettingsField(
              field.children[0],
              conditions,
              level + 1,
              opts,
            ),
          )
          conditions.pop()
        }
        /* False (No) Node */
        if (field.children[1]) {
          const key = field.key
          conditions.push((settings) => {
            return settings.get(key) === 'false'
          })
          fieldConfigs = fieldConfigs.concat(
            this.buildSiteSettingsField(
              field.children[1],
              conditions,
              level + 1,
              opts,
            ),
          )
          conditions.pop()
        }
        break
      case 'DynamicOptional':
        fieldConfigs.push({
          label: field.name,
          name: field.key,
          key: field.key,
          disabled: opts.disabled || field.readOnly,
          level: level,
          type: 'dynamicyesNo',
          conditions: conditions.slice(),
        })

        /* True (Yes) Node */
        if (field.children[0]) {
          const key = field.key
          conditions.push((settings) => {
            return settings.get(key) === 'true'
          })
          fieldConfigs = fieldConfigs.concat(
            this.buildSiteSettingsField(
              field.children[0],
              conditions,
              level + 1,
              opts,
            ),
          )
          conditions.pop()
        }
        /* False (No) Node */
        if (field.children[1]) {
          const key = field.key
          conditions.push((settings) => {
            return settings.get(key) === 'false'
          })
          fieldConfigs = fieldConfigs.concat(
            this.buildSiteSettingsField(
              field.children[1],
              conditions,
              level + 1,
              opts,
            ),
          )
          conditions.pop()
        }
        break
      case 'Group':
        field.children.forEach((child) => {
          if (field.key.includes('terminal.interface.autoscan.product')) {
            const autoscanSettingEnableIndex = 8
            const productNumber = this.extractProductNumber(field.key)
            if (autoscanSettingEnableIndex > productNumber || !productNumber) {
              fieldConfigs = fieldConfigs.concat(
                this.buildSiteSettingsField(child, conditions, level, opts),
              )
            }
          } else {
            fieldConfigs = fieldConfigs.concat(
              this.buildSiteSettingsField(child, conditions, level, opts),
            )
          }
        })
        break
    }

    return fieldConfigs
  }

  private extractProductNumber(key: string): number | null {
    const match = key.match(/product(\d+)/)
    return match ? parseInt(match[1], 10) : null
  }

  private convertOptions(options: string[]): DFFieldConfigChoice[] {
    const convertedOptions = []
    options.forEach((option) => {
      convertedOptions.push({
        label: option,
        value: option,
      })
    })
    return convertedOptions
  }
}
